export class UserDetailResponse {
	userName: string;
	firstName: string;
	lastName: string;
	language: string;
	activeCourse: number;
}
